<template>
	<div class="card-body">
		<form>
			<small class="form-text text-muted mb-3">
				These are miscelaneous modifiers that you might need to adjust. You usually won't need to adjust these unless you get a bonus from somewhere.
			</small>
			<input-number label="initiative" v-model="initiative" />
			<input-number label="resolve" v-model="resolve" />
			<input-number label="carry_capacity" v-model="carry_capacity" />
			<div class="form-group row">
				<label for="casting_stat" class="col-sm-3 col-form-label">Casting Stat</label>
				<div class="col-sm-9">
					<b-form-select v-model="casting_stat" id="casting_stat" :options="casting_stat_options"></b-form-select>
				</div>
			</div>
			<input-number label="spell_save_DC" v-model="spell_save_DC" />
		</form>
	</div>
</template>

<script>
function mapEverything( mod, properties ){
	var computed = {}
	properties.forEach(property => {
		computed[property] = {
			get () {
				return this.$store.getters[`${mod}/get`](property)
			},
			set ( value ){
				this.$store.commit(`${mod}/set`,{
					property,
					value
				})
			}
		}
	})
	return computed
}
import InputNumber from '@/components/InputNumber.vue'

export default {
	data() {
		return {
			casting_stat_options: [
				'Strength',
				'Dexterity',
				'Constitution',
				'Intelligence',
				'Wisdom',
				'Charisma',
			]
		}
	},
	components: {
		InputNumber,
	},
	computed: {
		...mapEverything('character/misc',[
			'carry_capacity',
			'casting_stat',
			'initiative',
			'resolve',
			'spell_save_DC',
		]),
	},
}
</script>

<style scoped>

</style>